"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEzbuyTrunk = exports.getRequestHost = void 0;
var index_1 = require("./utils/index");
var ezProductionDomain = ["ezbuy.sg", "ezbuy.my", "ezbuy.co.th", "pk.ezbuy.com", "tw.ezbuy.com"];
var ezUatDomain = ["65emall.net", "65emall.cn"];
var mcProductionDomain = ["ezbuy.com"];
var mcUATDomain = ["ezbuy.dev"];
var ltDomain = ["lightinthebox.com"];
var miniLTDomain = ["miniinthebox.com"];
var getRequestHost = function (isMobile, isUat, countrycode) {
    var host = location.host;
    if (index_1.matchInHost(mcProductionDomain) || index_1.matchInHost(mcUATDomain)) {
        return isUat ? (isMobile ? "m" : "web") + ".ezbuy.dev" : host;
    }
    if (index_1.matchInHost(ltDomain)) {
        return (isMobile ? "m" : "www") + ".lightinthebox.com";
    }
    if (index_1.matchInHost(miniLTDomain)) {
        return (isMobile ? "m" : "www") + ".miniinthebox.com";
    }
    return isUat ? countrycode + ".65emall.net" : (isMobile ? (host || "").replace("m.", "") : host);
};
exports.getRequestHost = getRequestHost;
var isEzbuyTrunk = function () {
    return index_1.matchInHost(ezProductionDomain) || index_1.matchInHost(ezUatDomain);
};
exports.isEzbuyTrunk = isEzbuyTrunk;
